"use strict";

var app = angular.module('rmOrganisation');
